export default __webpack_public_path__ + "static/media/circle-flags_ie.b1624acd.svg";